import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  const isAdmin = !!user && user.role === "admin";
  const can = (section) => isAdmin || (!!user && ["view", "edit"].includes(user.permissions?.[section]));
  const canEdit = (section) => isAdmin || (!!user && user.permissions?.[section] === "edit");

  return <AuthContext.Provider value={{ user, login, logout, isAdmin, can, canEdit }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
